import EventTypeSelector from '../EventTypeSelector';
import ServiceDateField from '../ServiceDateField';
import ServiceNotesField from '../ServiceNotesField';
import ServicePhotosField from '../ServicePhotosField';
import ServiceTargetFields from '../ServiceTargetFields';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LogServiceForm: FunctionComponent<Props> = ({
    className = '',
    draft,
    drone,
    isRemainingLifeValid,
    onAddPhotos,
    onChangeCalibrationKind,
    onChangeEventType,
    onChangeNotes,
    onChangePart,
    onChangePartCondition,
    onChangePartSerialNumber,
    onChangePerformedAt,
    onChangeRemainingLife,
    onChangeUnit,
    onRemovePhoto,
    serviceIntervals,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${styles.logServiceForm} ${className}`} testId={testId}>
        <EventTypeSelector onSelect={onChangeEventType} selectedEventType={draft.eventType} />

        <ServiceTargetFields
            draft={draft}
            drone={drone}
            isRemainingLifeValid={isRemainingLifeValid}
            onChangeCalibrationKind={onChangeCalibrationKind}
            onChangePart={onChangePart}
            onChangePartCondition={onChangePartCondition}
            onChangePartSerialNumber={onChangePartSerialNumber}
            onChangeRemainingLife={onChangeRemainingLife}
            onChangeUnit={onChangeUnit}
            serviceIntervals={serviceIntervals}
        />

        <ServiceDateField onChange={onChangePerformedAt} value={draft.performedAt} />

        <ServiceNotesField notes={draft.notes} onChange={onChangeNotes} />

        <ServicePhotosField
            onAddPhotos={onAddPhotos}
            onRemovePhoto={onRemovePhoto}
            photos={draft.photos}
        />
    </VerticalContainer>
);

export default LogServiceForm;
